<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-md-9">
        <div class="row margin-b">
          <div class="col-md-12">
            <div class="section-bar margin-b">
              <button class="icon-btn" title="Back">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div class="section-title flex-1 text-center">Association Manager</div>
              <button class="btn btn-sm section-action" [hidden]="!isActiveTab('satellite')" (click)="openAddSatellite(addSatelliteModal)">
                <i class="fas fa-user-plus"></i> Add Satellite Campus
              </button>
            </div>

            <div class="btn-group margin-b tabs" role="group" aria-label="Association Tabs">
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('associations')"
                [ngClass]="isActiveTab('associations') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('associations')">Association</button>
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('headquarter')"
                [ngClass]="isActiveTab('headquarter') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('headquarter')">Headquarters</button>
              <button type="button" class="btn btn-sm" [class.active]="isActiveTab('satellite')"
                [ngClass]="isActiveTab('satellite') ? 'main-backgroundcolor color' : 'btn-outline-secondary'"
                (click)="switchTab('satellite')">Satellites</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-xs-12 min-height">
            <div *ngIf="loading">
              <div class="card">
                <div class="card-body text-center" style="color:#6c757d; font-weight:500;">Loading...</div>
              </div>
            </div>

            <div class="card" *ngIf="!loading">
              <div class="card-header table-header main-backgroundcolor color">
                <div class="th name" style="flex:0 0 28%;max-width:28%;">Name</div>
                <div class="th location" style="flex:0 0 34%;max-width:34%;">Location</div>
                <div class="th email" style="flex:0 0 20%;max-width:20%;">Email</div>
                <div class="th status" style="flex:0 0 10%;max-width:10%;">Status</div>
                <div class="th action" style="flex:0 0 8%;max-width:8%;text-align:right;">Action</div>
              </div>
              <div class="card-body p-0">
                <div *ngFor="let association of getFilteredAssociations()" class="table-row">
                  <div class="td name" style="flex:0 0 28%;max-width:28%;">
                    <div class="partner-left">
                      <img [src]="authService.spilturl(association?.community?.photo)" alt="" class="partner-avatar" (error)="authService.geterrorImage($event)">
                      <div class="flex-1">
                        <div class="partner-name truncate-1">{{ association?.community?.name || '—' }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="td location" style="flex:0 0 34%;max-width:34%;">
                    <div class="partner-location" [title]="association?.community?.primaryAddress?.address || '—'" style="display:block;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ association?.community?.primaryAddress?.address || '—' }}</div>
                  </div>
                  <div class="td email" style="flex:0 0 20%;max-width:20%;">
                    <div class="partner-email" [title]="association?.community?.email || '—'" style="display:block;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ association?.community?.email || '—' }}</div>
                  </div>
                  <div class="td status" style="flex:0 0 10%;max-width:10%;">
                    <span class="badge" [ngClass]="{
                        'badge-success': association?.status === 'approved',
                        'badge-danger': association?.status === 'rejected',
                        'badge-pending': association?.status !== 'approved' && association?.status !== 'rejected'
                      }">{{ association?.status || 'pending' }}</span>
                  </div>
                  <div class="td action" style="flex:0 0 8%;max-width:8%;text-align:right;">
                    <div class="action-buttons">
                      <!-- Remove button for associations tab -->
                      <button *ngIf="isActiveTab('associations')" 
                        type="button" 
                        class="btn btn-sm btn-outline-danger"
                        (click)="removeAssociation(association)">
                        Remove
                      </button>
                      <!-- Approve/Reject buttons for headquarter tab -->
                      <ng-container *ngIf="isActiveTab('headquarter')">
                        <button type="button" 
                          class="btn btn-sm btn-success"
                          style="margin-right: 8px;"
                          (click)="approveAssociation(association)">
                          Approve
                        </button>
                        <button type="button" 
                          class="btn btn-sm btn-outline-danger"
                          (click)="rejectAssociation(association)">
                          Reject
                        </button>
                      </ng-container>
                      <!-- Remove button for satellite tab -->
                      <button *ngIf="isActiveTab('satellite')" 
                        type="button" 
                        class="btn btn-sm btn-outline-danger"
                        (click)="removeAssociation(association)">
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="getFilteredAssociations().length === 0" class="table-row" style="justify-content: center; padding: 40px 20px;">
                  <div style="text-align: center; color: #6c757d; font-weight: 500;">
                    No records found
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Satellite Selector Modal -->
<ng-template #addSatelliteModal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color">Add Satellite Campus</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body" (scroll)="satelliteModalStep === 'choose' ? onSelectorScroll($event) : null" style="max-height: 420px; overflow: auto;">
    <!-- Step 1: Choose -->
    <ng-container *ngIf="satelliteModalStep === 'choose'">
      <div class="form-group">
        <input type="text" class="form-control" placeholder="Search communities" (input)="onCommunitySearchChange($event)">
      </div>
      <div *ngFor="let c of filteredCommunities" class="card margin-b">
        <div class="card-body community-card">
          <div class="community-left">
            <img [src]="authService.spilturl(c.photo)" (error)="authService.geterrorImage($event)" alt="" style="width:50px;height:50px;border-radius:4px;object-fit:cover;">
            <div class="flex-1">
              <div class="truncate-1" style="font-weight:600;">{{ c.name }}</div>
              <div class="text-muted small truncate-1">{{ c.shortBio }}</div>
            </div>
          </div>
          <div class="checkbox-col">
            <input type="checkbox" [checked]="isCommunitySelected(c._id)" (change)="toggleCommunitySelection(c)">
          </div>
        </div>
      </div>
      <div class="text-center" *ngIf="selLoading" style="padding:8px;color:#6c757d;">Loading...</div>
    </ng-container>

    <!-- Step 2: Confirm -->
    <ng-container *ngIf="satelliteModalStep === 'confirm'">
      <div class="mb-2" style="font-weight:600;">Selected Satellite Campus</div>
      <div *ngIf="selectedCommunities.length === 0" class="text-muted small">No satellite selected.</div>
      <div *ngFor="let c of selectedCommunities" class="card margin-b">
        <div class="card-body community-card">
          <div class="community-left">
            <img [src]="authService.spilturl(c.photo)" (error)="authService.geterrorImage($event)" alt="" style="width:50px;height:50px;border-radius:4px;object-fit:cover;">
            <div class="flex-1">
              <div class="truncate-1" style="font-weight:600;">{{ c.name }}</div>
              <div class="text-muted small truncate-1">{{ c.shortBio }}</div>
            </div>
          </div>
          <div class="checkbox-col">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleCommunitySelection(c)">Remove</button>
          </div>
        </div>
      </div>
      <div class="text-center" *ngIf="submittingSatellite" style="padding:8px;color:#6c757d;">Submitting...</div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')" [disabled]="submittingSatellite">Cancel</button>

    <ng-container *ngIf="satelliteModalStep === 'choose'">
      <button type="button" class="btn main-backgroundcolor color"
        [disabled]="!selectedCommunityIds.length"
        (click)="goToSatelliteConfirm()">
        Select
      </button>
    </ng-container>

    <ng-container *ngIf="satelliteModalStep === 'confirm'">
      <button type="button" class="btn btn-outline-secondary" (click)="backToSatelliteChoose()" [disabled]="submittingSatellite">Back</button>
      <button type="button" class="btn main-backgroundcolor color"
        [disabled]="submittingSatellite || !selectedCommunityIds.length"
        (click)="submitSelectedSatellites(modal)">
        Submit Satellite
      </button>
    </ng-container>
  </div>
</ng-template>
